import axios from 'axios'
import { KEYCLOAK_CONFIG, apiUrl } from '../app-config'
import { removeLocalStorage } from '../Layouts/utils'

const xcpemSec = axios.create({
  baseURL: apiUrl
})

let isRefreshing = false
let refreshSubscribers: ((token: string) => void)[] = []

const refreshToken = async () => {
  try {
    const token = localStorage.getItem('refresh_token')
    if (!token) {
      // handleLogout()
      throw new Error('Refresh token not found')
    }

    const body = new URLSearchParams()
    body.append('client_id', KEYCLOAK_CONFIG.CLIENT_ID)
    body.append('client_secret', KEYCLOAK_CONFIG.CLIENT_SECRET)
    body.append('grant_type', 'refresh_token')
    body.append('refresh_token', token)

    const response = await axios.post(
      `${KEYCLOAK_CONFIG.URL}/auth/realms/${KEYCLOAK_CONFIG.REALM}/protocol/openid-connect/token`,
      body
    )
    const newAccessToken = response.data.access_token
    const newRefreshToken = response.data.refresh_token

    localStorage.setItem('access_token', newAccessToken)
    localStorage.setItem('refresh_token', newRefreshToken)

    isRefreshing = false
    refreshSubscribers.forEach(cb => cb(newAccessToken))
    refreshSubscribers = []

    return newAccessToken
  } catch (error) {
    handleLogout()
    throw error
  }
}

const handleLogout = () => {
  removeLocalStorage()
  window.location.href = '/login'
}

xcpemSec.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem('access_token')
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  error => Promise.reject(error)
)

xcpemSec.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    if (
      (error.response.status === 401 && !originalRequest._retry) ||
      (typeof error.response?.data === 'string' && error.response?.data?.includes('UNAUTHORIZED'))
    ) {
      originalRequest._retryCount = originalRequest._retryCount || 0

      if (originalRequest._retryCount >= 1) {
        console.log('Refresh token failed twice. Logging out...')
        handleLogout()
        return Promise.reject(error)
      }

      if (!isRefreshing) {
        isRefreshing = true
        try {
          originalRequest._retryCount += 1
          const newAccessToken = await refreshToken()
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
          return xcpemSec(originalRequest)
        } catch (err) {
          return Promise.reject(err)
        } finally {
          isRefreshing = false
        }
      } else {
        return new Promise((resolve, reject) => {
          refreshSubscribers.push(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            resolve(xcpemSec(originalRequest))
          })
        })
      }
    }

    return Promise.reject(error)
  }
)

export default xcpemSec
